module.exports = __webpack_public_path__ + "static/media/error-sound.cb2d09c5.mp3";